import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notAvailable',
  standalone: false,
})
export class NotAvailablePipe implements PipeTransform {
  transform(value: any, ...args: any[]): string {
    if (value === null || value === undefined) {
      return 'N/A';
    }
    return value;
  }
}